import React, {useEffect, useState} from 'react';
import {Linking, TouchableWithoutFeedback, View} from "react-native";
import {styles} from "./LoginButtonViewStyle";
import {TranslationView} from "@levelapp/softfabric-ui";
import {getToken} from "../../../../../../../Common/Utils/token.utils";

interface LoginButtonViewProps {
    isVisible: boolean;
    divStyle: any;
    setToken: (token: string | undefined) => void;
}

export default function LoginButtonView({isVisible, divStyle, setToken}: LoginButtonViewProps) {

    const [isHovered, setIsHovered] = useState(false);

    const visibleHrefStyle = isHovered ? styles.buttonHover : styles.buttonDefault;

    useEffect(() => {
        setToken(getToken());
    }, [getToken]);

    function onLoginPress() {
        Linking.openURL("https://my.beebonds.com/fr-BE/login");
    }

    return isVisible ? (
        <TouchableWithoutFeedback
            onPressIn={() => setIsHovered(true)}
            onPressOut={() => setIsHovered(false)}
            onPress={onLoginPress}
        >
            <View style={[styles.button, visibleHrefStyle, {paddingVertical: 3}]}>
                <TranslationView
                    style={[styles.buttonText, isHovered ? styles.buttonTextHover : styles.buttonTextDefault]}>login</TranslationView>
            </View>
        </TouchableWithoutFeedback>
    ) : (
        <TouchableWithoutFeedback onPress={onLoginPress}>
            <View style={[styles.buttonDefault, divStyle]}>
                <TranslationView
                    style={styles.buttonTextMobile}>login</TranslationView>
            </View>
        </TouchableWithoutFeedback>
    );
}